<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="mt-3">
        <p class="font-weight-bold mb-0">{{$t('medium_grant_ev.admissibility__title_of_proposal')}}</p>
        <span>{{application.title}}</span>
      </div>
      <div class="mt-3">
        <p class="font-weight-bold mb-0">{{$t('medium_grant_ev.admissibility__region')}}</p>
        <span v-if="application.region_details">{{application.region_details.name}}</span> <span v-else>-</span>
      </div>
      <div class="mt-3">
        <p class="font-weight-bold mb-0">{{$t('medium_grant.technical__1_priority_landscape')}}</p>
        <span v-if="application.region_details">{{application.data.technical.priority_landscape}}</span>
        <span v-else>-</span>
      </div>
      <div class="mt-3">
        <p class="font-weight-bold mb-0">{{$t('medium_grant.technical__1_name_lead_org')}}</p>
        <span v-if="application.region_details">{{application.data.technical.name_of_lead_org}}</span>
        <span v-else>-</span>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: ['application']
  }
</script>